// Page header: display-face h1, optional lede, optional actions slot.
// Structure: shadcn-ui/ui apps/v4/registry/new-york-v4/blocks/dashboard-01/components/site-header.tsx — MIT (title + right-aligned actions).

import type { ReactNode } from "react";

/** Dashboard page-title role (DESIGN.md §4: display face for dashboard page
 *  titles). Shared with screens that render their own h1 (Login). */
export const pageTitleClass = "font-display text-3xl font-semibold text-fg-0";
/** Lede under a page title. */
export const pageLedeClass = "max-w-[60ch] text-fg-1";

export function PageHeader({
  title,
  lede,
  actions,
}: {
  title: string;
  lede?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header
      data-slot="page-header"
      className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between"
    >
      <div className="flex min-w-0 flex-col gap-2">
        <h1 className={pageTitleClass}>{title}</h1>
        {lede && <p className={pageLedeClass}>{lede}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-3">{actions}</div>}
    </header>
  );
}
